import { exportProducerCode } from "actions/CarrierAgreementMgmt/ProducerCodeConfig";
import { useMutation } from "react-query";

const useExportProducerCode = () => {
  return useMutation(exportProducerCode);
};
export default useExportProducerCode;
